
import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";

const BuyerLandingFooter = () => {
  return (
    <footer className="border-t border-gray-800 py-8 px-4">
      <div className="container mx-auto text-center text-gray-400">
        <Logo className="text-[#ffd700] mb-2" />
        <a 
          href="https://play.google.com/store/apps/details?id=app.lovable.a458feef936a4fdd9306ef7eae220648"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-transform hover:scale-105 mb-4 inline-block"
        >
          <img 
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            alt="Get it on Google Play"
            className="h-10"
          />
        </a>
        <p className="mb-4">&copy; 2024 GoDyspo. All rights reserved.</p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <Link 
            to="/consumer" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Consumer Products
          </Link>
          <Link 
            to="/buyer/faq" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            FAQ
          </Link>
          <Link 
            to="/contact" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Contact Us
          </Link>
          <Link 
            to="/privacy-policy" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms-and-conditions" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default BuyerLandingFooter;
